/**
 * UI-facing types for the audio capture surface. These are derived from the
 * canonical pipeline snapshot via `projectCapturePipelineUiState` and consumed
 * by presentational components (transcript panel, toolbar, header, indicators).
 *
 * Keeping them separate from the pipeline internals lets UI avoid depending on
 * stage/outcome enums directly while still reading canonical state.
 */
export enum AudioCapturePhase {
  Ready = "ready",
  Initializing = "initializing",
  Recording = "recording",
  Paused = "paused",
  Uploading = "uploading",
  Processing = "processing",
  Stopped = "stopped",
}

export type AudioCaptureToolbarPrimaryAction =
  | { kind: "done"; isDisabled: boolean }
  | { kind: "retry"; ariaLabel: string }
  | { kind: "retry-all"; ariaLabel: string }
  | { kind: "record-again"; ariaLabel: string };

export type AudioCaptureToolbarState = {
  processingLabel: string;
  primaryAction: AudioCaptureToolbarPrimaryAction;
  showCancel: boolean;
  retryTargets: {
    upload: boolean;
    transform: boolean;
    retryAll: boolean;
  };
};
